import { useParams, useNavigate } from "react-router-dom";

export default function EventPackages() {
  const { type } = useParams();
  const navigate = useNavigate();
  const data = packages[type];

  if (!data) {
    return (
      <section className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center">
        <h2 className="font-['Playfair_Display'] text-4xl text-gray-900 mb-4">Package not found</h2>
        <p className="text-gray-500 font-light mb-8">Please select a valid event type from the Events menu.</p>
        <button onClick={() => navigate("/")} className="text-xs uppercase tracking-widest border-b border-gray-900 pb-1">Return Home</button>
      </section>
    );
  }

  return (
    <div className="bg-white min-h-screen overflow-x-hidden">
      
      {/* 🏛️ Sophisticated Header Section */}
      <section className="relative pt-32 pb-20 px-6 text-center">
        {/* Large Faded Background Heading for Depth */}
        <div className="absolute top-10 left-1/2 -translate-x-1/2 pointer-events-none opacity-[0.03] select-none">
          <h1 className="text-[12vw] font-['Playfair_Display'] whitespace-nowrap uppercase tracking-tighter">Experiences</h1>
        </div>

        <div className="relative z-10">
          <span className="text-[10px] uppercase tracking-[0.5em] text-pink-400 font-bold mb-4 block">
            Branding & Events Studio
          </span>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-normal text-gray-900 tracking-tight leading-tight">
            {data.title.split(' ')[0]} <span className="italic text-neutral-700">{data.title.split(' ')[1]}</span>
          </h1>
          <div className="w-12 h-[1px] bg-neutral-200 mx-auto mt-10" />
          <p className="mt-10 text-neutral-500 max-w-xl mx-auto font-light leading-relaxed text-base md:text-lg italic">
            "{data.subtitle}"
          </p>
        </div>
      </section>

      {/* 💎 Pricing Cards Grid */}
      <section className="max-w-7xl mx-auto px-6 pb-32">
        <div className={`grid gap-10 md:gap-14 ${data.plans.length === 1 ? 'max-w-md mx-auto' : 'grid-cols-1 md:grid-cols-2'}`}>
          {data.plans.map((plan) => (
            <div 
              key={plan.name} 
              className="group relative bg-white border border-neutral-100 rounded-[3rem] p-10 md:p-14 transition-all duration-700 hover:-translate-y-4 hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.1)] overflow-hidden"
            >
              {/* Internal Gradient Glow */}
              <div className="absolute inset-0 z-0 opacity-10 group-hover:opacity-30 transition-opacity duration-700 pointer-events-none"
                   style={{ background: 'radial-gradient(circle at top right, #ff9aa2, #d9f3ff, transparent)' }} />

              <div className="relative z-10 flex flex-col h-full">
                <div className="flex justify-between items-start mb-8">
                  <div>
                    <h3 className="font-['Playfair_Display'] text-3xl text-gray-900 mb-2">{plan.name}</h3>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-teal-600 font-bold">The Offering</p>
                  </div>
                  <p className="text-lg font-light text-gray-400">{plan.price}</p>
                </div>

                <div className="w-full h-[1px] bg-neutral-100 mb-10" />

                <ul className="flex flex-col gap-6 mb-12 flex-grow">
                  {plan.features.map((item) => (
                    <li key={item} className="flex items-center gap-4 text-gray-500 font-light text-sm md:text-base">
                      <span className="w-1.5 h-1.5 rounded-full bg-pink-200" />
                      {item}
                    </li>
                  ))}
                </ul>

                <button 
                  onClick={() => navigate("/contact")}
                  className="w-full py-5 rounded-full bg-neutral-900 text-white text-[11px] uppercase tracking-[0.3em] font-medium hover:bg-pink-400 transition-all duration-500 shadow-lg"
                >
                  Enquire Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ✉️ Minimal Footer Callout */}
      {/* <section className="bg-neutral-50/50 py-24 text-center border-t border-neutral-100">
         <p className="text-[10px] uppercase tracking-[0.4em] text-gray-400 mb-4">Need something custom?</p>
         <h4 className="font-['Playfair_Display'] text-2xl text-gray-900 mb-8">Tailored experiences for unique visions.</h4>
         <button onClick={() => navigate("/contact")} className="text-xs font-bold border-b-2 border-pink-200 pb-1 hover:border-neutral-900 transition-all">
           Request a Custom Quote
         </button>
      </section> */}
    </div>
  );
}

/* DATA - Keeping your structure intact */
const packages = {
  weddings: {
    title: "Wedding Packages",
    subtitle: "Designed to make your special day effortless and unforgettable",
    plans: [
      { 
        name: "Essential", 
        price: "From R19,000", 
        features: ["30 Guests", "Catering (2-Course Meal)", "Backdrop", "Photographery Hire (8 hours)", "Wedding Cake", "Hair & Makeup Artist","Digital Invitations", "Timeline planning"] 
      }
      // { 
      //   name: "Luxury", 
      //   price: "From R30,000", 
      //   features: ["Full event planning", "On-the-day coordination", "Styling & décor management"] 
      // }
    ]
  },
  birthdays: {
    title: "Birthday Packages",
    subtitle: "Celebrate in style with thoughtfully curated experiences",
    plans: [
      { name: "Classic", price: "From R13,000", features: ["30 Guests", "Backdrop", "Photographery Hire (3 hours)", "Cake", "2/3 Course Meals", "Hair & Makeup Artist", "Digital Invitations"] },
      { name: "Premium", price: "From R19,000", features: ["50 Guests", "Backdrop", "Photographery Hire (3 hours)", "Cake", "2/3 Course Meal", "Hair & Makeup Artist", "Digital Invitations"] }
    ]
  },
  corporate: {
    title: "Corporate Packages",
    subtitle: "Professional events executed with precision and polish",
    plans: [
      { name: "Business", price: "From R10,000", features: ["Logistics planning", "AV coordination", "Brand alignment"] }
    ]
  },
  special: {
    title: "Matric Ball Packages",
    subtitle: "Tailored experiences for life’s most meaningful moments",
    plans: [
      { name: "Ball Ready", price: "From R9,000", features: ["Backdrop", "Photographer (3 hours)", "Cake", "Platters (5 items per platter)", "Hair & Makeup Artist" ] }
    ]
  }
  // other: {
  //   title: "Other Events",
  //   subtitle: "Tailored experiences for life’s most meaningful moments",
  //   plans: [
  //     { name: "Custom", price: "Price on request", features: ["Concept design", "End-to-end planning", "Event execution"] }
  //   ]
  // }
};